import React, { useCallback } from 'react';
import { DropZone } from '../../../../types';

interface UseTabDragAndDropProps {
  startDrag: (tabId: string, containerId: string) => void;
  endDrag: () => void;
  handleDropZone: (dropZone: DropZone, draggedTabId: string, draggedFromPaneId: string) => void;
  startDragOverlay: (tabId: string, containerId: string, dragElement: HTMLElement) => void;
  endDragOverlay: () => void;
}

/**
 * タブのドラッグ&ドロップ操作を管理するカスタムフック
 */
export function useTabDragAndDrop({
  startDrag,
  endDrag,
  handleDropZone,
  startDragOverlay,
  endDragOverlay
}: UseTabDragAndDropProps) {
  
  // タブのドラッグ開始
  const onTabDragStart = useCallback((tabId: string, containerId: string, event: React.DragEvent) => {
    startDrag(tabId, containerId);
    
    // ドラッグオーバーレイを開始
    startDragOverlay(tabId, containerId, event.currentTarget as HTMLElement);
  }, [startDrag, startDragOverlay]);
  
  // タブのドラッグ終了
  const onTabDragEnd = useCallback(() => {
    endDrag();
    endDragOverlay();
  }, [endDrag, endDragOverlay]);
  
  // ドロップゾーンへのドロップ
  const onDropZoneDrop = useCallback((
    dropZone: DropZone, 
    draggedTabId: string, 
    draggedFromPaneId: string
  ) => {
    
    handleDropZone(dropZone, draggedTabId, draggedFromPaneId);
    
    // ドラッグ状態をクリア
    endDrag();
    endDragOverlay();
  }, [handleDropZone, endDrag, endDragOverlay]);
  
  return {
    onTabDragStart,
    onTabDragEnd,
    onDropZoneDrop
  };
}